import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const INDUSTRIES_DATA = [
  {
    title: "Professional Services",
    description:
      "Accelerate research, improve knowledge work, automate repetitive tasks and help your teams deliver better outcomes for every client.",
    image: "/images/opportunities/ind_card_1.png",
    link: "/ai-opportunities?tab=Industries&industry=Professional%20Services#explore-opportunities-by",
  },
  {
    title: "Manufacturing",
    description:
      "Improve production efficiency, predict disruptions, strengthen quality and connect operational intelligence across the factory.",
    image: "/images/opportunities/ind_card_2.png",
    link: "/ai-opportunities?tab=Industries&industry=Manufacturing#explore-opportunities-by",
  },
  {
    title: "Healthcare",
    description:
      "Reduce administrative burden, make information easier to access and support clinical and operational teams with timely insights.",
    image: "/images/opportunities/ind_card_3.png",
    link: "/ai-opportunities?tab=Industries&industry=Healthcare#explore-opportunities-by",
  },
  {
    title: "Financial Services",
    description:
      "Strengthen risk management, streamline financial operations, detect anomalies and deliver more personalized customer experiences.",
    image: "/images/opportunities/ind_card_4.png",
    link: "/ai-opportunities?tab=Industries&industry=Financial%20Services#explore-opportunities-by",
  },
  {
    title: "Education",
    description:
      "Personalize learning experiences, empower educators, simplify administration and help institutions make better decisions with AI.",
    image: "/images/opportunities/ind_card_5.png",
    link: "/ai-opportunities?tab=Industries&industry=Education#explore-opportunities-by",
  },
  {
    title: "Retail & Consumer",
    description:
      "Understand customer needs, personalize engagement, optimize inventory and help teams respond faster to changing demand.",
    image: "/images/opportunities/ind_card_6.png",
    link: "/ai-opportunities?tab=Industries&industry=Retail%20%26%20Consumer#explore-opportunities-by",
  },
  {
    title: "Social Impact",
    description:
      "Empower communities, expand access to essential services, improve program outcomes and help mission-driven organizations turn resources into measurable impact.",
    image: "/images/opportunities/ind_card_7.png",
    link: "/ai-opportunities?tab=Industries&industry=Social%20Impact#explore-opportunities-by",
  },
  {
    title: "Government",
    description:
      "Simplify citizen services, improve policy and operational insights, and make public-sector workflows more accessible and efficient.",
    image: "/images/opportunities/ind_card_8.png",
    link: "/ai-opportunities?tab=Industries&industry=Government#explore-opportunities-by",
  },
];

const IndustriesSection = () => {
  return (
    <section
      id="industries"
      className="w-full border-y border-[#E2E8F0]/80 bg-[#F1F2F4] py-20 sm:py-24"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-[70px]">
        {/* Section Header */}
        <div className="mb-12 flex flex-col gap-3">
          <p className="text-[11px] font-bold uppercase tracking-[2.5px] text-[#64748B] sm:text-[12px]">
            OUR INDUSTRIES
          </p>
          <h2 className="text-[28px] font-bold leading-tight text-[#0F172A] sm:text-[36px] lg:text-[42px]">
            Industries we serve with AI-Powered Solutions
          </h2>
        </div>

        {/* 8 Industry Cards Grid (4 cols on desktop) */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {INDUSTRIES_DATA.map((item) => (
            <Link
              key={item.title}
              to={item.link}
              className="group flex flex-col justify-between overflow-hidden rounded-[12px] border border-[#E2E8F0] bg-white transition-all duration-300 hover:shadow-[0_4px_30px_rgba(0,0,0,0.15)] min-h-[352px]"
            >
              {/* Card Image - stationary without any zoom/scale on hover */}
              <div className="relative w-full aspect-[218/125] overflow-hidden bg-slate-100 flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full object-cover"
                />
              </div>

              {/* Content & Bottom Action Button */}
              <div className="relative flex flex-1 flex-col justify-between gap-5 p-5 bg-white overflow-hidden">
                {/* Hover Gradient Overlay */}
                <div
                  className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(5, 214, 218, 0.18) 100%)",
                  }}
                />

                <div className="relative z-10 flex flex-col gap-2">
                  <h3 className="text-[17px] font-bold leading-snug text-[#0F172A]">
                    {item.title}
                  </h3>
                  <p className="text-[13px] font-normal leading-[21px] text-[#64748B]">
                    {item.description}
                  </p>
                </div>

                {/* Circular Brand Gradient Arrow Button */}
                <div className="relative z-10 flex justify-end pt-1">
                  <div className="relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-full border border-[#05D6DA] bg-white text-[#05D6DA] shadow-[0_2px_12px_rgba(5,214,218,0.25)] transition-all duration-300 group-hover:border-transparent group-hover:text-white group-hover:shadow-[0_4px_16px_rgba(5,214,218,0.45)]">
                    {/* Brand gradient on hover */}
                    <div
                      className="absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(5, 214, 218, 1) 0%, rgba(49, 112, 247, 1) 100%)",
                      }}
                    />
                    <ArrowUpRight
                      className="relative z-10 h-4 w-4 transition-colors duration-200"
                      strokeWidth={2.4}
                    />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
